import React, { useEffect, useState } from "react";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import ButtonPrimary from "../../../../components/button/ButtonPrimary";
import {
  setSummarizePopup,
  setSummaryInfoData,
  setSummaryPopup,
  setUrl,
} from "../../../../redux/features/dataSlice";
import { useDispatch } from "react-redux";
import CustomLoader from "../../../../components/loader";
import { toast } from "react-toastify";
import { openaiAPI } from "../../../../apis";
import Draggable from "react-draggable";
import { useIsMobile } from "../../../../functions/isMobile";
import { useSelector } from "react-redux";
import {
  customSummary1,
  customSummary2,
  customSummaryLoading,
} from "../../../../constants";

const CustomSummarize = (props) => {
  const isMobile = useIsMobile();

  const {
    setDesc,
    setIsDescExternal,
    setSummaryText,
    summaryText,
    setSummarizePopupNa,
  } = props;
  const [loading, setLoading] = useState(false);
  const { summarizePopup } = useSelector((state) => state.data);
  const [closePage, setClosePage] = useState(false);

  const [localSummaryText, setLocalSummaryText] = useState("");

  const dispatch = useDispatch();
  const [error, setError] = useState(false);
  const [position, setPosition] = useState({
    marginTop: 0,
    marginLeft: 0,
  });

  const setErrorMessage = () => {
    setDesc(
      "We're sorry, we could not fetch the content of this article. Try using the Custom Summarizer in the toolbar above by manually opening the article, copy its content, paste it into the Custom Summarizer, then click Generate. You will be able to save it as a separate bookmark."
    );
    setError(true);
  };

  const handleGenerateSummary = async () => {
    if (summaryText.length < 10) {
      toast.error(
        "The text you've entered is too short to generate a summary. Please provide a longer text."
      );
      return;
    }
    dispatch(setUrl(""));
    dispatch(setSummaryInfoData({}));
    setLoading(true);
    setSummarizePopupNa(true);

    try {
      const response = await axios.post(
        openaiAPI.getSummary,
        {
          summary: summaryText,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (closePage) {
        return;
      }

      const generatedSummary = response.data.generated_summary;
      if (
        response.data.error === "index out of range in self" ||
        response.data.error?.length > 0
      ) {
        throw error;
      }
      setIsDescExternal(true);
      setDesc(generatedSummary);

      const bullets = Object.keys(generatedSummary)
        .filter((key) => key.startsWith("bullet"))
        .map((key) => generatedSummary[key]);
      setDesc(bullets.join("\n\n"));

      dispatch(setSummaryPopup(false));
      dispatch(setSummarizePopup(true));
    } catch (error) {
      console.error("Error generating summary:", error);
      toast.error(
        "An error occured while generating the summary. Please try again."
      );
      dispatch(setSummarizePopup(false));
      setSummaryText("");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (closePage) {
      dispatch(setSummarizePopup(false));
    }
  }, []);

  useEffect(() => {
    setSummaryText("");
  }, []);

  const handleDrag = (e, ui) => {
    const { x, y } = ui;
    setPosition((prevPosition) => ({
      ...prevPosition,
      marginTop: y,
      marginLeft: x,
    }));
    console.log(x, y);
  };

  return (
    <>
      {console.log(closePage)}
      {console.log("custom summarize")}
      <div className="bg-dark" />
      {!isMobile ? (
        <Draggable
          defaultPosition={{ x: position.marginLeft, y: position.marginTop }}
          onDrag={handleDrag}
          cancel={isMobile ? ".custom-summarize-popup" : null}
        >
          <div className="custom-summarize-popup">
            <div className="popup-card">
              <>
                <CloseIcon
                  className="cross"
                  onClick={() => {
                    setSummaryText("");
                    setClosePage(true);
                    setSummarizePopupNa(false);
                    dispatch(setSummarizePopup(false));
                    dispatch(setSummaryPopup(false));
                  }}
                />
                {loading && <p className="mt-2">{customSummaryLoading}</p>}
                {loading ? (
                  <CustomLoader height="40rem" style={true} />
                ) : (
                  <>
                    <p className="popup-title">Your Summarization Tool</p>
                    <p>{customSummary1}</p>
                    <p>{customSummary2}</p>
                    <div className="save-actions">
                      <div className="flex-btn mt-2">
                        <ButtonPrimary
                          text="Generate"
                          className="close"
                          onClick={handleGenerateSummary}
                        />
                      </div>
                    </div>
                    <div className="comment-container flow">
                      <textarea
                        className="desc edit-textarea"
                        value={localSummaryText}
                        onChange={(e) => {
                          setLocalSummaryText(e.target.value);
                        }}
                        onBlur={(e) => setSummaryText(e.target.value)}
                      />
                    </div>
                  </>
                )}
              </>
            </div>
          </div>
        </Draggable>
      ) : (
        <div className="custom-summarize-popup">
          <div className="popup-card">
            <>
              <CloseIcon
                className="cross"
                onClick={() => {
                  setSummaryText("");
                  setClosePage(true);
                  setSummarizePopupNa(false);
                  dispatch(setSummarizePopup(false));
                  dispatch(setSummaryPopup(false));
                }}
              />
              {loading && <p className="mt-2">{customSummaryLoading}</p>}
              {loading ? (
                <CustomLoader height="40rem" style={true} />
              ) : (
                <>
                  <p className="popup-title">Your Summarization Tool</p>
                  <p>{customSummary1}</p>
                  <p>{customSummary2}</p>
                  <div className="save-actions">
                    <div className="flex-btn mt-2">
                      <ButtonPrimary
                        text="Generate"
                        className="close"
                        onClick={handleGenerateSummary}
                      />
                    </div>
                  </div>
                  <div className="comment-container flow">
                    <textarea
                      className="desc edit-textarea"
                      value={localSummaryText}
                      onChange={(e) => {
                        setLocalSummaryText(e.target.value);
                      }}
                      onBlur={(e) => setSummaryText(e.target.value)}
                    />
                  </div>
                </>
              )}
            </>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomSummarize;
